import * as React from 'react';

const HeadMetadata = ({
  title,
  description,
  keywords,
  canonical,
  seo,
  externalHreflangs,
  withoutGoogle,
  withoutPricespider,
  withoutSearchConfiguration,
}) => {
  const googleTagId = process.env.GATSBY_GOOGLE_TAG_ID || '';

  return (
    <>
      <html lang={seo?.html_lang_attribute} dir={seo?.html_dir_attribute} />
      <meta charSet="UTF-8" />
      <title>{title}</title>
      <meta name="description" content={description} />
      {keywords ? <meta name="keywords" content={keywords} /> : null}
      <meta name="viewport" content="width=device-width, initial-scale=1" />
      <link rel="shortcut icon" href="/favicon.ico" />
      <link rel="icon" type="image/png" sizes="16x16" href="/favicon-16x16.png" />
      <link rel="icon" type="image/png" sizes="32x32" href="/favicon-32x32.png" />
      <link rel="canonical" href={canonical} />
      {externalHreflangs?.map((link) => {
        return (
          <link key={link.hreflang} rel="alternate" href={link.hreflang} hrefLang={link.url} />
        );
      })}
      <meta name="ps-key" content="1732-5e543b7c3533c60025faeeea" />
      <meta name="ps-country" content={seo?.ps_country} />
      <meta name="ps-language" content={seo?.ps_language} />

      {/* Google Tag Manager script */}
      {!withoutGoogle && googleTagId && (
        <script
          dangerouslySetInnerHTML={{
            __html: `
              (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
              new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
              j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
              'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
              })(window,document,'script','dataLayer','${googleTagId}');
            `,
          }}
        />
      )}

      {!withoutSearchConfiguration && (
        <script
          dangerouslySetInnerHTML={{
            __html: `window.addsearchConfigurationShared = {"indexKey":"b66b6bb61d3750e920569be3a43b360c","language":"${seo?.ps_language}","region":"${seo?.ps_region}","imageSourceDomain":""};`,
          }}
        />
      )}
    </>
  );
};

export default HeadMetadata;
